/* generated by pull.js */
const manifest = {
    "name": "Costume Gradient Editor",
    "description": "Adds a custom gradient maker to the costume editor, available next to the other gradient options.",
    "credits": [
        {
            "name": "SharkPool",
            "link": "https://github.com/SharkPool-SP/"
        }
    ],
    "userscripts": [
        {
            "url": "userscript.js"
        }
    ],
    "tags": ["editor", "recommended"],
    "enabledByDefault": true,
    "dynamicEnable": true,
    "dynamicDisable": false
};
export default manifest;